import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";

import { ProductDetailsPageContext } from "@insite/content-library/Pages/ProductDetailsPage";
import ProductQuantityBreakPricingTable from "@MasterBluePrint/Components/ProductQuantityBreakPricingTable";
import ProductQuantityBreakPricing, {
    ProductQuantityBreakPricingStyles,
} from "@MasterBluePrint/Overrides/Components/ProductQuantityBreakPricing";
import * as React from "react";
import { css } from "styled-components";

const enum fields {
    displayQtyBreakPricingInTable = "displayQtyBreakPricingInTable",
  
}
interface OwnProps {
    fields: {
        [fields.displayQtyBreakPricingInTable]: boolean;     
    };
}
type Props = OwnProps & WidgetProps & HasProduct;

export interface ProductDetailsQuantityBreakPricingStyles {
    quantityBreakPricing?: ProductQuantityBreakPricingStyles;
}

export const quantityBreakPricingStyles: ProductDetailsQuantityBreakPricingStyles = {
    quantityBreakPricing: {
        viewLink: {
            css: css`
                margin: .5rem 0;
            `,
        },
    },
};

const styles = quantityBreakPricingStyles;

const ProductDetailsQuantityBreakPricing: React.FC<Props> = ({ product,fields,productInfo: { pricing} }) => {
    if (!product) {
        return null;
    }
    if (product && pricing?.actualPrice === 0 && pricing?.actualPriceDisplay === "Call") {
        return null
    }
    if (fields.displayQtyBreakPricingInTable)
    {
        return <ProductQuantityBreakPricingTable extendedStylesTable={styles.quantityBreakPricing}  />;
    }
    return <ProductQuantityBreakPricing extendedStyles={styles.quantityBreakPricing}  />;
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsQuantityBreakPricing),
    definition: {
        displayName: "Quantity Break Pricing",
        group: "Product Details",
        allowedContexts: [ProductDetailsPageContext],
        fieldDefinitions: [{
            name: fields.displayQtyBreakPricingInTable,
            displayName: "Display Quantity Break Pricing In Table",
            editorTemplate: "CheckboxField",
            defaultValue: false,
            fieldType: "General",
        }],
    },
};

export default widgetModule;
